import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetPortalUserTableData: '[GetPortalUserTableData] Action',
  SetPortalUserData: '[SetPortalUserData] Action',
  GetPortalUserTranslateData: '[GetPortalUserTranslateData] Action',
}

const initialPortalUserState: IPortalUserState = {
  columnList: [],
  columnValues: [],
  definitions: [],
  columnNames: [],
  dataTypes: [],
  de: [],
  en: [],
  editables: [],

  options: []
}

export interface IPortalUserState {
  columnValues: [],
  columnList: [],
  definitions: []
  columnNames: [],
  dataTypes: [],
  de: [],
  en: [],
  editables: [],

  options: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-portaluser', whitelist:  [ ] },
  (state: IPortalUserState = initialPortalUserState, action: any) => {
    switch (action.type) {
      case actionTypes.GetPortalUserTableData: {
        const columnValues = action.payload.data.contactPersons;
        let headers = JSON.parse(action.payload.data.headers);
        let definitions = JSON.parse(action.payload.data.definitions);
        let options = action.payload.data.options;
        let columnNames = action.payload.data.columnNames;
        let dataTypes = action.payload.data.dataTypes;
        let editables = action.payload.data.editables;
        let columnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          columnList.push(newElement[0]);
        });
        return { ...state, columnList, columnValues,editables, definitions, options, dataTypes , columnNames};
      }
    
      case actionTypes.SetPortalUserData: {
        const columnValues = action.payload.data;
        return { ...state, columnValues };
      }

      case actionTypes.GetPortalUserTranslateData: {
        const de = JSON.parse(action.payload.data.de);
        const en = JSON.parse(action.payload.data.en);
        return { ...state, de, en };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getPortalUserTableData: (data: any) => ({ type: actionTypes.GetPortalUserTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetPortalUserTranslateData, payload: { data } }),
  setPortalUserData: (data: any) => ({ type: actionTypes.SetPortalUserData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
